import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalOutlinedLogoutIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.5 5.5C9.5 5.78 9.72 6 10 6C10.28 6 10.5 5.78 10.5 5.5V3.5C10.5 2.67 9.83 2 9 2H2C1.17 2 0.5 2.67 0.5 3.5V12.5C0.5 13.33 1.17 14 2 14H9C9.83 14 10.5 13.33 10.5 12.5V10.5C10.5 10.22 10.28 10 10 10C9.72 10 9.5 10.22 9.5 10.5V12.5C9.5 12.78 9.28 13 9 13H2C1.72 13 1.5 12.78 1.5 12.5V3.5C1.5 3.22 1.72 3 2 3H9C9.28 3 9.5 3.22 9.5 3.5V5.5Z",
			fill: "#4B7987",
			stroke: "#4B7987",
			strokeWidth: .5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.35 8.35047C15.55 8.15047 15.55 7.84047 15.35 7.64047L12.57 4.88047C12.37 4.68047 12.06 4.68047 11.86 4.88047C11.66 5.08047 11.66 5.39047 11.86 5.59047L13.79 7.49047H5C4.72 7.49047 4.5 7.71047 4.5 7.99047C4.5 8.27047 4.72 8.49047 5 8.49047H13.79L11.86 10.3805C11.66 10.5805 11.66 10.8905 11.86 11.0905C12.06 11.2905 12.37 11.2905 12.57 11.0905L15.35 8.34047V8.35047Z",
			fill: "#4B7987",
			stroke: "#4B7987",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgPortalOutlinedLogoutIcon);
const Memo = memo(ForwardRef);
export default Memo;
